import { useEffect, useState } from "react";
import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";
import { useApi, errMsg } from "../lib/api";
import { listClashes, dropClash, CLASH_EVENT } from "../lib/offline";
import { offlineNow } from "../lib/idb";

const L = { P: "Present", A: "Absent", H: "Half day", L: "Leave" };

export const AttendanceClashes = ({ onDone }) => {
  const api = useApi();
  const [list, setList] = useState(listClashes);
  useEffect(() => {
    const f = () => setList(listClashes());
    window.addEventListener(CLASH_EVENT, f);
    return () => window.removeEventListener(CLASH_EVENT, f);
  }, []);
  if (!list.length) return null;
  const mine = async (c) => {
    try { await api.post("/attendance", { date: c.date, entries: [{ worker_id: c.worker_id, status: c.mine }] }); dropClash(c); toast.success(`${c.name}: your mark saved`); onDone(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const btn = "rounded-md border px-2.5 py-1 text-[11px] transition-colors disabled:opacity-40";
  return (
    <div className="c-surface c-rise mb-4 p-4 !border-amber-400/30" data-testid="attendance-clashes">
      <div className="flex items-center gap-2 text-sm text-amber-200 font-semibold"><AlertTriangle size={15} />{list.length} attendance clash{list.length > 1 ? "es" : ""}</div>
      <p className="text-xs text-slate-400 mt-1 mb-3">Someone changed these marks online after this phone saved its copy. The online marks were kept. Choose yours only if it's correct.</p>
      {list.map((c) => {
        const id = `${c.worker_id}-${c.date}`;
        return (
          <div key={id} className="flex flex-wrap items-center justify-between gap-2 py-2 border-t border-[#1F2A3E]/60" data-testid={`clash-row-${id}`}>
            <span className="text-sm">{c.name} <span className="text-[11px] text-slate-500 font-mono ml-1">{c.date}</span>
              <span className="block text-[11px] text-slate-400">Online: <b className="text-white">{L[c.online]}</b> · Yours: <b className="text-white">{L[c.mine]}</b></span></span>
            <span className="flex gap-1.5">
              <button onClick={() => mine(c)} disabled={offlineNow()} className={`${btn} border-amber-400/40 text-amber-200 hover:bg-amber-400/10`} data-testid={`clash-use-mine-${id}`}>Use mine</button>
              <button onClick={() => dropClash(c)} className={`${btn} border-[#1F2A3E] text-slate-300 hover:bg-[#1A2234]`} data-testid={`clash-keep-online-${id}`}>Keep online</button>
            </span>
          </div>);
      })}
    </div>);
};
